import React, { useEffect, useState, useMemo, FC } from 'react';
import axios from 'axios';
import { StyledCellText } from 'molecules/Table/styles/Text.styles';
import Table from 'molecules/Table';
import {
  StyledCellContainer,
  StyledTableContainer,
} from 'molecules/Table/styles';
import OrgReportPreview from 'molecules/OrgReportPreview';
import { OrgReport } from 'pages/CloudOpsReport';
import Link from 'atoms/Link/Link';
import { Button, Stack } from '@mui/material';
import { OrgCostReport } from 'organisms/OrgReportPDF/types';
// import OverviewSummary from 'organisms/CompanyOverviewBlock/OverviewSummary';

const ObervabilityReport: FC<{ connectorId?: string }> = ({ connectorId }) => {
  const [orgReports, setOrgReports] = useState<OrgReport[]>([]);
  const [loader, setLoader] = useState(true);

  const [orgReportPreview, setOrgReportPreview] =
    useState<OrgCostReport | null>(null);

  const formatMonthYear = (iso: string) =>
    new Date(iso).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
    });

  const columns = useMemo(
    () => [
      {
        key: 'month',
        label: 'Month',
        sortable: false,
        width: '20%',
        render: ({ Report }: OrgReport) => (
          <StyledCellText $textType="bold">
            {formatMonthYear(Report.time_now).replace(' ', ', ')}
          </StyledCellText>
        ),
      },
      {
        key: 'project',
        label: 'Project Name',
        sortable: false,
        width: '40%',
        render: ({ ConnectorName }: OrgReport) => (
          <StyledCellText $textType="default">{ConnectorName}</StyledCellText>
        ),
      },
      {
        key: 'report',
        label: 'Report',
        sortable: false,
        width: '40%',
        render: ({ Report }: OrgReport) => (
          <StyledCellContainer $hStack $left>
            <Button
              onClick={() => setOrgReportPreview(Report)}
              variant="text"
              size="small"
              sx={{ maxWidth: '120px' }}
            >
              View Report
            </Button>
            <Link to={`/company/${Report.id}`} $textDecoration="none">
              <StyledCellText $textType="link">Observability</StyledCellText>
            </Link>
          </StyledCellContainer>
        ),
      },
    ],
    []
  );

  //   const summaryData = useMemo(
  //     () => ({
  //       totalAccounts: orgReports.length,
  //       actualCost: orgReports.reduce(
  //         (acc, curr) => acc + curr.Report.annual_saving,
  //         0
  //       ),
  //       potentialCost: orgReports.reduce(
  //         (acc, curr) => acc + curr.Report.annual_spend,
  //         0
  //       ),
  //       savingsPercentage:
  //         orgReports.length === 0
  //           ? 0
  //           : ((orgReports.reduce(
  //               (acc, curr) => acc + curr.Report.annual_spend,
  //               0
  //             ) -
  //               orgReports.reduce(
  //                 (acc, curr) => acc + curr.Report.annual_saving,
  //                 0
  //               )) /
  //               orgReports.reduce(
  //                 (acc, curr) => acc + curr.Report.annual_spend,
  //                 0
  //               )) *
  //             100,
  //     }),
  //     [orgReports]
  //   );

  useEffect(() => {
    if (!connectorId) return;

    (() => {
      setLoader(true);

      axios
        .get(
          `${process.env.REACT_APP_USER_SERVICE}/finops/organizations/reports/${connectorId}`
        )
        .then((p) => {
          setOrgReports(p.data);
        })
        .finally(() => {
          setLoader(false);
        });
    })();
  }, [connectorId]);

  return (
    <Stack sx={{ m: 2, gap: 2 }}>
      {/* <OverviewSummary
        totalAccounts={summaryData.totalAccounts}
        actualCost={summaryData.actualCost}
        potentialCost={summaryData.potentialCost}
        savingsPercentage={summaryData.savingsPercentage}
      /> */}
      <StyledTableContainer style={{ minWidth: 800 }}>
        <Table
          idKey="id"
          loading={loader}
          columns={columns}
          data={orgReports || []}
        />
      </StyledTableContainer>

      {orgReportPreview && (
        <OrgReportPreview
          report={orgReportPreview}
          onClose={() => {
            document.body.setAttribute('id', '');
            setOrgReportPreview(null);
          }}
        />
      )}
    </Stack>
  );
};

export default ObervabilityReport;
